import { trackEvent } from 'shared/helpers/Analytics';
import {
  LoadSuggestionDTO,
  SHIPPER_RECOMMENDED_ALGORITHM,
} from '../data/LoadSuggestionDTO';
import { PostingDTO } from '../../../../loadboard/data/dto/PostingDTO';

export type SuggestedLoadOpenUtmMedium =
  | 'Available Tab'
  | 'Suggested Tab'
  | 'Suggested Load Drawer';

export type SuggestionBasedOn = 'drivers' | 'dispatcher_activity';

export function getSuggestionBasedOn(
  load: LoadSuggestionDTO,
): SuggestionBasedOn | undefined {
  if (!load.driver_names) {
    return undefined;
  }

  return load.driver_names.length > 0 ? 'drivers' : 'dispatcher_activity';
}

export function isSuggestedByShipper(load: LoadSuggestionDTO): boolean {
  return load.algorithms.includes(SHIPPER_RECOMMENDED_ALGORITHM);
}

export function trackSuggestedLoadClickEventWithPosting(
  posting: PostingDTO,
  utmMedium?: string,
) {
  trackSuggestedLoadClickEvent({
    loadGuid: posting.load.guid,
    postingGuid: posting.load.posting_guid,
    suggestedByShipper: !!posting.is_shipper_recommended,
    utmMedium,
  });
}

export function trackSuggestedLoadClickEventWithSuggestion(
  load: LoadSuggestionDTO,
  utmMedium: SuggestedLoadOpenUtmMedium,
) {
  trackSuggestedLoadClickEvent({
    loadGuid: load.guid,
    postingGuid: load.posting_guid,
    loadSuggestionGuid: load.suggestion_guid,
    suggestionBasedOn: getSuggestionBasedOn(load),
    suggestedByShipper: isSuggestedByShipper(load),
    utmMedium,
  });
}

interface TrackSuggestedLoadClickEventParams {
  loadGuid: string;
  postingGuid: string | null;
  loadSuggestionGuid?: string;
  suggestionBasedOn?: SuggestionBasedOn;
  suggestedByShipper: boolean;
  utmMedium?: string;
}

function trackSuggestedLoadClickEvent({
  loadGuid,
  postingGuid,
  loadSuggestionGuid,
  suggestionBasedOn,
  suggestedByShipper,
  utmMedium,
}: TrackSuggestedLoadClickEventParams) {
  trackEvent('Carrier Clicked Suggested Load', {
    load_guid: loadGuid,
    posting_guid: postingGuid,
    load_suggestion_guid: loadSuggestionGuid,
    suggestion_based_on: suggestionBasedOn,
    suggested_by_shipper: suggestedByShipper,
    utm_medium: utmMedium,
  });
}
